import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Icon from '@xo-union/tk-component-icons';
import BlankButton from '@xo-union/component-blank-button';
import { OnboardingContext, STEPS } from '../../OnboardingContext';
import styles from './index.scss';
import { FeatureToggleEnum, useFeatureTogglesContext } from '../../../context/FeatureTogglesContext';
interface Props {
  buttonText?: string;
  className?: string;
}
const BackButton: React.FC<Props> = ({ buttonText = 'Back', className = '' }) => {
  const { canGoBack, onBack, step, onSubmit, onboardingType } = useContext(OnboardingContext);
  const history = useHistory();
  const { isEnabled } = useFeatureTogglesContext();

  const goBack = () => {
    if (step === STEPS.BASIC_INFO && onboardingType === 'AI') {
      onSubmit({ type: 'PROPS_CHANGED', payload: { onboardingType: undefined } });
      history.push('/gs/wedding-websites');
    } else if (step === STEPS.BASIC_INFO) {
      history.push('/gs/wedding-websites');
    } else {
      onBack();
    }
  };

  if (!canGoBack || (isEnabled(FeatureToggleEnum.AiOnboarding) && onboardingType === undefined)) {
    return null;
  }

  return (
    <div className={`${styles.backButtonContainer} ${className}`}>
      <BlankButton className={styles.backButton} onClick={goBack}>
        <Icon name="back" size="md" />
        <span className={styles.buttonText}>{buttonText}</span>
      </BlankButton>
    </div>
  );
};

export default BackButton;
